var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useCreatePollMutation } from '../../store/services/pollsApi';
import { CreatePollReq } from '../../helpers/proto/plugnmeet_polls_pb';
const Create = () => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [question, setQuestion] = useState('');
    const [createPoll, { isLoading, data }] = useCreatePollMutation();
    const [options, setOptions] = useState([
        {
            id: 1,
            text: '',
        },
        {
            id: 2,
            text: '',
        },
    ]);
    useEffect(() => {
        if (!isLoading && data) {
            if (data.status) {
                toast(t('polls.created-successfully'), {
                    type: 'info',
                });
            }
            else {
                toast(t(data.msg), {
                    type: 'error',
                });
            }
            closeModal();
        }
    }, [isLoading, data]);
    const closeModal = () => {
        setIsOpen(false);
        setQuestion('');
        setOptions([
            {
                id: 1,
                text: '',
            },
            {
                id: 2,
                text: '',
            },
        ]);
    };
    const onSubmit = (e) => {
        e.preventDefault();
        const body = new CreatePollReq({
            question,
            options,
        });
        createPoll(body);
    };
    const onChange = (index, e) => {
        const currenOptions = [...options];
        currenOptions[index].text = e.currentTarget.value;
        setOptions([...currenOptions]);
    };
    const removeOption = (index) => {
        const currenOptions = [...options];
        currenOptions.splice(index, 1);
        setOptions([...currenOptions]);
    };
    const addOption = () => {
        const currenOptions = [...options];
        const newOpt = {
            id: currenOptions[currenOptions.length - 1].id + 1,
            text: '',
        };
        currenOptions.push(newOpt);
        setOptions([...currenOptions]);
    };
    const renderForm = () => {
        return (_jsxs("form", { onSubmit: onSubmit, children: [_jsx("label", { className: "text-base text-black dark:text-darkText block mb-1", children: t('polls.enter-question') }), _jsx("input", { type: "text", name: "question", value: question, required: true, onChange: (e) => setQuestion(e.currentTarget.value), placeholder: "Ask a question", className: "text-black placeholder:text-black/50 py-2 px-4 text-base w-full border border-solid border-primaryColor outline-none rounded-lg mb-4 bg-transparent dark:border-darkText dark:text-darkText placeholder:text-darkText" }), _jsxs("div", { className: "flex items-start justify-between pb-2 pt-4 border-t border-solid border-primaryColor/20 dark:border-darkText/30", children: [_jsx("p", { className: "text-lg text-black dark:text-darkText block leading-4", children: t('polls.options') }), _jsx("button", { className: "h-7 px-3 leading-[28px] text-center transition ease-in bg-primaryColor hover:bg-secondaryColor text-white text-sm font-semibold rounded-lg", type: "button", onClick: () => addOption(), children: t('polls.add-new-option') })] }), _jsx("div", { className: "option-field-wrapper overflow-auto h-full max-h-[345px] scrollBar scrollBar2", children: _jsxs("div", { className: "option-field-inner", children: [options.map((elm, index) => (_jsx("div", { className: "form-inline mb-4", children: _jsxs("div", { className: "input-wrapper w-full flex items-center", children: [_jsx("input", { type: "text", required: true, name: `opt_${elm.id}`, value: elm.text, onChange: (e) => onChange(index, e), placeholder: t('polls.option', {
                                                count: index + 1,
                                            }).toString(), className: "text-black placeholder:text-black/50 py-2 px-4 text-base w-[calc(100%-36px)] border border-solid border-primaryColor outline-none rounded-lg bg-transparent dark:text-darkText dark:border-darkText placeholder:text-darkText" }), index ? (_jsx("button", { type: "button", className: "ml-2 p-1", onClick: () => removeOption(index), children: _jsx("i", { className: "pnm-delete w-5 h-5 dark:text-secondaryColor" }) })) : null] }) }, elm.id))), isLoading ? (_jsx("div", { className: "loading absolute text-center top-1/2 -translate-y-1/2 z-[999] left-0 right-0 m-auto", children: _jsxs("div", { className: "lds-ripple", children: [_jsx("div", { className: "border-secondaryColor" }), _jsx("div", { className: "border-secondaryColor" })] }) })) : null] }) }), _jsx("div", { className: "button-section flex items-center justify-end", children: _jsx("button", { className: "h-8 px-6 leading-[32px] text-center transition ease-in bg-primaryColor hover:bg-secondaryColor text-white text-base font-semibold rounded-lg", type: "submit", children: t('polls.create-poll') }) })] }));
    };
    const renderModal = () => {
        return (_jsx(_Fragment, { children: _jsx(Transition, { appear: true, show: isOpen, as: Fragment, children: _jsx(Dialog, { as: "div", className: "fixed inset-0 z-[9999] overflow-y-auto", onClose: () => false, children: _jsxs("div", { className: "min-h-screen px-4 text-center", children: [_jsx(Transition.Child, { as: Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in duration-200", leaveFrom: "opacity-100", leaveTo: "opacity-0", children: _jsx(Dialog.Overlay, { className: "fixed inset-0 bg-black opacity-30" }) }), _jsx("span", { className: "inline-block h-screen align-middle", "aria-hidden": "true", children: "\u200B" }), _jsx(Transition.Child, { as: Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0 scale-95", enterTo: "opacity-100 scale-100", leave: "ease-in duration-200", leaveFrom: "opacity-100 scale-100", leaveTo: "opacity-0 scale-95", children: _jsxs("div", { className: "inline-block w-full max-w-lg p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-darkPrimary shadow-xl rounded-2xl", children: [_jsxs("button", { className: "close-btn absolute top-8 right-6 w-[25px] h-[25px] outline-none", type: "button", onClick: () => closeModal(), children: [_jsx("span", { className: "inline-block h-[1px] w-[20px] bg-primaryColor dark:bg-darkText absolute top-0 left-0 rotate-45" }), _jsx("span", { className: "inline-block h-[1px] w-[20px] bg-primaryColor dark:bg-darkText absolute top-0 left-0 -rotate-45" })] }), _jsx(Dialog.Title, { as: "h3", className: "text-lg font-medium leading-6 text-gray-900 dark:text-white text-left mb-2", children: t('polls.create') }), _jsx("hr", {}), _jsx("div", { className: "mt-6", children: renderForm() })] }) })] }) }) }) }));
    };
    return (_jsxs(_Fragment, { children: [isOpen ? renderModal() : null, _jsx("button", { onClick: () => setIsOpen(true), className: "w-[calc(100%-20px)] ml-[10px] h-10 leading-[40px] text-center transition ease-in bg-primaryColor hover:bg-secondaryColor text-white text-base font-semibold rounded-lg mb-2", children: t('polls.create') })] }));
};
_react_refresh_temp_1 = Create;
$RefreshReg$(_react_refresh_temp_1, "Create");
_react_refresh_temp_2(Create, "dI/yjuKEEksJDKL7JX9pYEAUROA=", false, () => [useTranslation, useCreatePollMutation]);
export default Create;
